module.exports = __webpack_public_path__ + "img/ad1.53822ff8.jpg";